const initPbiSection = () => {
  const sections = document.querySelectorAll(".pbi-section");
  sections.forEach(section => {
    const panel = section.querySelector(".pbi-grid");
    if (panel) {
      initCarousel(panel);
    }
  });
}

document.addEventListener("DOMContentLoaded", initPbiSection);

function initCarousel(panel) {
  if (!panel) return;

  const track = panel.querySelector(".pbi-track");
  const cards = panel.querySelectorAll(".pbi-card");
  // const prev = panel.querySelector(".prev");
  // const next = panel.querySelector(".next");
  const progress = panel.querySelector(".pbi-progress span");

  const isMobile = () => window.innerWidth <= 768;
  const total = cards.length;
  // const visibleDesktop = 3;
  // let index = 0;

  /*  MOBILE  */
  if (isMobile()) {
    panel.classList.add("carousel");
    track.style.transform = "none";

    cards.forEach(c => c.classList.remove("is-active"));
    cards[0]?.classList.add("is-active");

    progress.style.width = `${100 / total}%`;

    track.addEventListener("scroll", () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) return;

      const scrollRatio = track.scrollLeft / maxScroll;
      const currentIndex = Math.round(scrollRatio * (total - 1));

      progress.style.width = `${((currentIndex + 1) / total) * 100}%`;

      cards.forEach(c => c.classList.remove("is-active"));
      cards[currentIndex]?.classList.add("is-active");
    });

    return;
  }

  /*  DESKTOP  */
  // const visible = visibleDesktop;
  // const maxIndex = total - visible;

  // function updateButtons() {
  //   if (!prev || !next) return;
  //   prev.classList.toggle("is-active", index > 0);
  //   next.classList.toggle("is-active", index < maxIndex);
  // }

  // function update() {
  //   index = Math.max(0, Math.min(index, maxIndex));
  //   track.style.transform = `translateX(-${index * (100 / visible)}%)`;
  //   progress.style.width = `${((index + visible) / total) * 100}%`;
  //   updateButtons();
  // }

  // if (prev) {
  //   prev.onclick = () => {
  //     index--;
  //     update();
  //   };
  // }

  // if (next) {
  //   next.onclick = () => {
  //     index++;
  //     update();
  //   };
  // }

  // update();
}
